import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIBanner from 'UIComponents/alert/UIBanner';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { OBSIDIAN, OLAF, CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import SkeletonCircle from 'ui-addon-upgrades/_core/common/components/loading/SkeletonCircle';
import SkeletonText from 'ui-addon-upgrades/_core/common/components/loading/SkeletonText';
import SkeletonBox from 'ui-addon-upgrades/_core/common/components/loading/SkeletonBox';

const LoadingBanner = ({
  className,
  style = {},
  'data-test-id': dataTestId
}) => {
  const bannerStyle = Object.assign({}, style, {
    color: OBSIDIAN,
    background: OLAF,
    minHeight: '82px',
    border: `1px solid ${CALYPSO_MEDIUM}`,
    borderRadius: '5px',
    gap: '16px 0'
  });
  return /*#__PURE__*/_jsx(UIBanner, {
    style: bannerStyle,
    className: className,
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsxs(UIFlex, {
      className: "p-y-3",
      wrap: "wrap",
      align: "center",
      justify: "center",
      children: [/*#__PURE__*/_jsx(UIBox, {
        basis: 250,
        grow: 100,
        className: "flex-wrap align-center",
        style: {
          gap: '8px 0'
        },
        children: /*#__PURE__*/_jsxs(UIBox, {
          className: "m-right-4 align-center",
          grow: 1,
          style: {
            lineHeight: 1
          },
          children: [/*#__PURE__*/_jsx(SkeletonCircle, {
            size: 24
          }), /*#__PURE__*/_jsx(SkeletonText, {
            className: "m-left-4",
            width: "30%"
          }), /*#__PURE__*/_jsx(SkeletonText, {
            className: "m-left-4",
            width: "40%"
          })]
        })
      }), /*#__PURE__*/_jsx(UIBox, {
        basis: 110,
        children: /*#__PURE__*/_jsx(SkeletonBox, {
          width: "107px",
          height: "40px"
        })
      })]
    })
  });
};

export default LoadingBanner;